

export const productsData = {
  
  axtream: {
    name: "Axtream",

    axtreamlogo: "/assets/axtream_banner_logo.png",

    heroTitle:
      "A real-time business intelligence platform for KPI monitoring, data quality visibility, and operational insights.",

    description:
      "Axtream is built for organizations that want to move from delayed, manual, and fragmented reporting to trusted, real-time intelligence. It helps teams reduce manual effort, improve data confidence, detect issues early, and make faster decisions using reliable data.",

    button: "Request a Demo",

    Productimage: "/assets/axtream_product_page_img.png",

    productlogo: "/assets/axtreme_logo.png",

    image: [
      "/assets/axt02.png",
      "/assets/axt03.png",
      "/assets/axt04.png",
      "/assets/axt05.png",
    ],

    demoSection: {
      title: "Experience Axtream Firsthand",
      description:
        "Request a demo with an Axtelica expert to explore how Axtream transforms your business data operations.",
      points: [
        "Connect enterprise systems and APIs",
        "Enable real-time and batch ingestion",
        "Improve data quality and governance",
        "Monitor KPIs and operational risks",
      ],
    },

    tabs: {
      overview: {
        title:
          "Real-time data integration, quality, and intelligence  ",

        Subtitles:
          "Axtream turns disconnected data into trusted, real-time business intelligence.",

        description:
          "Axtream helps businesses bring scattered data together from applications, databases, files, APIs, and streaming platforms. It gives teams cleaner data, faster reporting, and better visibility into what is happening across the business.",

        description2:
          "nstead of waiting for manual file checks, delayed reports, or repeated reconciliation, teams can use Axtream to ingest, validate, monitor, and activate data in near real time.",
      },

      features: {
        title: "Key Features",

        description:
          "Everything your business needs to manage trusted enterprise data and operational visibility from one platform.",

        tableData: [
          {
            feature: "One data gateway",
            details:
              "Connect enterprise applications, databases, files, cloud storage, APIs, and streaming platforms through one unified platform.",
          },

          {
            feature: "Real-time and batch ingestion",
            details:
              "Support both scheduled data loads and live data movement so business teams do not have to wait for critical insights.",
          },

          {
            feature: "Automated quality checks",
            details:
              "Spot missing values, duplicates, invalid formats, mismatches, and rule failures before they affect reports or decisions.",
          },

          {
            feature: "Anomaly and risk alerts",
            details:
              "Identify unusual patterns, operational risks, and data issues early instead of discovering them after month-end reporting.",
          },

          {
            feature: "AI-ready data foundation",
            details:
              "Prepare clean, trusted, and structured data that can support dashboards, analytics, AI models, and future automation.",
          },

          {
            feature: "KPI and data health dashboards",
            details:
              "Give business and technology teams a clear view of data flow, exceptions, quality scores, and operational KPIs.",
          },
        ],
      },

      benefits: {
        title: "Business Benefits",

        description:
          "Quantitative benefits for clients",

        tableData: [
          {
            impact: "30-50% faster data availability",
            details:
              "Reduce delays from manual file handling, delayed batch cycles, and disconnected systems.",
          },

          {
            impact: "40-60% less reconciliation effort",
            details:
              "Automate validation, matching, and exception identification across multiple sources.",
          },

          {
            impact: "25-40% better reporting accuracy",
            details:
              "Catch quality issues before they reach dashboards, MIS reports, or business users.",
          },

          {
            impact: "20-35% faster issue detection",
            details:
              "Identify missing records, anomalies, and operational risks earlier with automated monitoring.",
          },

          {
            impact: "30-45% less data preparation time",
            details:
              "Reduce time spent cleaning and reshaping data before analytics or AI use cases.",
          },

          
        ],
      },
    },

    FAQ: [
      {
        id: 1,
        question:
          "What makes Axtelica different from other data or IT providers?",
        answer:
          "Axtelica delivers AI-powered data platforms and accelerators that automate processes, reduce manual effort, and deliver faster business outcomes.",
      },

      {
        id: 2,
        question:
          "Can Axtream integrate with our existing enterprise systems?",
        answer:
          "Yes. Axtream is designed to integrate with enterprise applications, databases, APIs, cloud platforms, files, and streaming systems.",
      },

      {
        id: 3,
        question:
          "Does Axtream support real-time data processing?",
        answer:
          "Yes. Axtream supports both batch and real-time data ingestion and monitoring for faster operational insights.",
      },

      {
        id: 4,
        question:
          "How does Axtream improve data quality?",
        answer:
          "It automatically validates, monitors, and detects issues like duplicates, missing records, invalid formats, and reconciliation mismatches.",
      },

      {
        id: 5,
        question:
          "Can Axtream support analytics and AI initiatives?",
        answer:
          "Absolutely. Axtream prepares clean, structured, and trusted datasets for dashboards, analytics platforms, AI models, and automation.",
      },
    ],
  },


  infinisight: {
  name: "Infinisight",
  axtreamlogo: "/assets/infinisight_banner_logo.png",

  heroTitle: "Turn Your Data Into Intelligent Decisions",

  midleTitle: "Infinisight – Smarter Data. Faster Decisions.",

  midlePara:
    "Unlock the power of your business data with AI-driven dashboards, automated insights, and real-time analytics designed to accelerate growth.",

  botomtitle: "AI-powered insight and monitoring platform",

  bottompara:
    "Converts technical data into actionable insights for decision-makers.",

  description:
    "Infinisight is an intelligent analytics platform designed to help businesses convert data into strategic insights through dashboards, automation, and AI-driven reporting.",

  demoSection: {
    title: "Ready to unlock the power of your data?",

    description:
      "Request a demo with an Axtelica AI product expert to see how you can:",

    points: [
      "Connect data from multiple sources",
      "Ingest batch and real-time data",
      "Improve data quality and trust",
      "Detect anomalies and operational risks",
    ],
  },

  Productimage: "/assets/infinisight_product_page_img.png",

  productlogo: "/assets/infinisight_logo.png",

  image: [
    "/assets/inffi01.jpeg",
    "/assets/inffi02.jpeg",
    "/assets/inffi06.jpeg",
    "/assets/inffi04.jpeg",
    "/assets/inffi03.jpeg",
    "/assets/inffi05.jpeg",
  ],

  button: "Request a Demo",

  tabs: {
    overview: {
      title:
        "AI-powered business intelligence platform for dashboards, reporting, and strategic insights.",

      Subtitles:
        "Transform business data into faster and smarter decisions.",

      description:
        "Infinisight helps organizations integrate data, visualize KPIs, automate reporting, and generate actionable business insights from multiple systems in one centralized platform.",

      description2:
        "It enables leadership, operations, finance, and business teams to monitor performance in real time, identify trends faster, and improve decision-making with trusted analytics.",
    },

    features: {
      tableData: [
        {
          feature: "Unified Data Integration",
          details:
            "Connect CRM, ERP, APIs, cloud systems, files, and databases into one centralized analytics platform.",
        },

        {
          feature: "Real-Time Dashboards",
          details:
            "Monitor KPIs, operational metrics, and business performance with live dashboards and visual reports.",
        },

        {
          feature: "AI-Powered Insights",
          details:
            "Generate intelligent recommendations, trend analysis, and predictive insights for faster decision-making.",
        },

        {
          feature: "Automated Reporting",
          details:
            "Reduce manual reporting efforts with scheduled reports, alerts, and automated business summaries.",
        },

        {
          feature: "Live Data Processing",
          details:
            "Process and analyze streaming and batch data in near real time for better operational visibility.",
        },

        {
          feature: "Secure & Scalable Platform",
          details:
            "Support growing business data needs with enterprise-grade security, scalability, and governance.",
        },
      ],
    },

    benefits: {
      tableData: [
        {
          impact: "Faster Decision-Making",
          details:
            "Access real-time insights and analytics to make quicker and more confident business decisions.",
        },

        {
          impact: "Increased Productivity",
          details:
            "Reduce manual effort through automated reporting, dashboarding, and analytics workflows.",
        },

        {
          impact: "Better Data Visibility",
          details:
            "Provide leadership and teams with a single, trusted view of business performance and KPIs.",
        },

        {
          impact: "Improved Operational Efficiency",
          details:
            "Identify trends, risks, and bottlenecks earlier with proactive monitoring and analytics.",
        },

        {
          impact: "Cost Optimization",
          details:
            "Reduce operational inefficiencies and reporting overhead through centralized intelligence.",
        },

        {
          impact: "Better Accuracy",
          details:
            "Improve confidence in reporting and decision-making with validated and integrated business data.",
        },
      ],
    },
  },

  FAQ: [
    {
      id: 1,
      question: "What is Infinisight?",
      answer:
        "Infinisight is an intelligent analytics platform designed to help businesses convert data into strategic insights through dashboards, automation, and AI-driven reporting.",
    },

    {
      id: 2,
      question: "Who should use Infinisight?",
      answer:
        "It is ideal for startups, SMEs, enterprises, operations teams, finance teams, marketing teams, and executives who need accurate data insights.",
    },

    {
      id: 3,
      question: "How does Infinisight help businesses?",
      answer:
        "It centralizes data, tracks KPIs, automates reports, improves forecasting, and enables faster decision-making.",
    },

    {
      id: 4,
      question: "Is Infinisight cloud-based?",
      answer:
        "Yes. Users can securely access dashboards, analytics, and reports from anywhere.",
    },

    {
      id: 5,
      question: "Can small businesses use Infinisight?",
      answer:
        "Yes. Infinisight is designed for businesses of all sizes.",
    },
  ],
},

  Intelligent: {
    name: "AI-Powered SDLC Suite",
    axtreamlogo:"/assets/deliveryailogo.png",
    heroTitle: "AI-Powered SDLC Suite ",
     demoSection: {
      title: "Experience Axtelica Firsthand?",
      description:
        "Request a demo with an Axtelica AI product expert to see how you can:",
      points: [
        "Connect data from multiple sources",
        "Ingest batch and real-time data",
        "Improve data quality and trust",
        "Detect anomalies and operational risks",
      ],
    },
     FAQ: [
  {
    id: 1,
    question: "Is my data used to train AI models?",
    answer:
      "No. Your documents, requirements, and exports are never used to train foundation models or shared with third parties. Enterprise plans include signed DPAs.",
  },
  {
    id: 2,
    question: "What's included in the free plan?",
    answer:
      "3 runs per month, HTML export with watermark, and core AI requirement extraction. No credit card required.",
  },
  {
    id: 3,
    question: "When will Design Studio and Validation Studio be available?",
    answer:
      "Both are in active development. Join the waitlist on each module card to get early access when private beta opens.",
  },
  {
    id: 4,
    question: "Can you integrate with Jira, Azure DevOps, or Confluence?",
    answer:
      "Yes — integrations are on the Pro and Enterprise roadmap. Enterprise customers can request custom integrations directly.",
  },
  {
    id: 5,
    question: "Do you support SSO, on-prem, or private cloud?",
    answer:
      "SSO/SAML ships on Enterprise. On-prem and private cloud deployments are available for Enterprise customers — contact sales."
  },
]

     
      
    
  },
};